import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import KeyValueContainer from "../../../../shared/KeyValueContainer";
import {Card, Grid, Mui} from "@leap4/frontend";
import React, {useContext, useEffect, useState} from "react";
import {IAdServer, ITagMetrics} from "@leap4/entities-discrepancy-common";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {extractOverviewMetrics, getMetricChangePercent} from "../../../common/OverviewGeneralInfo/OverviewHelpers";
import {SingleMetricForCard} from "../../../common/OverviewGeneralInfo/SingleMetric";
import {metricEnumKeyMap} from "../../../../../utils/enums";


export interface IAdServerCardProps {
    adServer: IAdServer
    totals: ITagMetrics,
    compareData: ITagMetrics
}

export const AdServerCard = ({adServer, totals, compareData}: IAdServerCardProps): JSX.Element => {
    const {userViews} = useContext(UserViewsContext)
    const [initialAllMetrics] = useState(extractOverviewMetrics(totals))
    const [selectedDatesMetrics, setSelectedMetrics] = useState(extractOverviewMetrics(totals))
    const [compareDataMetrics, setCompareDataMetrics] = useState(extractOverviewMetrics(compareData))
    useEffect(() => {
        const {cardViews} = userViews.activePreset
        const newSelectedMetrics = {}
        cardViews.forEach(view => {
            newSelectedMetrics[view] = initialAllMetrics[view]
        })
        setSelectedMetrics(newSelectedMetrics as any)
        setCompareDataMetrics(extractOverviewMetrics(compareData))
    }, [userViews, compareData])


    return <Card
        className={'carded'}
        sx={{
            width: {
                lg: 500,
                xs: 350
            },
            margin: '10px auto', boxShadow: 'none', borderRadius: '16px'
        }}
        header={{
            title: adServer.name.toUpperCase(),
            subtitle: "TOTALS"
        }
        }
        actionsArea={{
            children:
                <Link
                    to={urlService.adServerOverview(adServer._id.toString(), true)}
                >
                    <Grid
                        alignContent="center" alignItems="center" container>
                        <Grid item xs={12}>
                            {Object.keys(selectedDatesMetrics).map(key => {

                                    let compareVal
                                    if (!compareDataMetrics) compareVal = null
                                    else compareVal = compareDataMetrics[key]
                                    return (
                                        <KeyValueContainer
                                            key={key + Math.random().toString()}
                                            title={metricEnumKeyMap[key].label.toUpperCase()}
                                            value={
                                                <SingleMetricForCard
                                                    metricValue={selectedDatesMetrics[key] as number}
                                                    metricEnum={metricEnumKeyMap[key].label}
                                                    metricChange={getMetricChangePercent(selectedDatesMetrics[key], compareVal)}
                                                />
                                            }
                                        />
                                    )

                                }
                            )
                            }
                        </Grid>
                    </Grid>
                </Link>
        }
        }
    />
}